//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Spi.WebClient.BalikyNepredaneSpisovneAC.ts           </Name>
//    <Description>                                                             </Description>
//    <Author>      Jiří Šindelka                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2018                            </Copyright>
//    <Created>     2018-07-18                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.Others
{
    @Decorators.gcontent
    export class StartPage extends GContentBase<Wfl.AC.WflBaseAC>
    {
        model: Interface.GPodAppSouhrnInfoDto;
        IfSpousteciUdalosti: boolean;
        scorecardItems: any[] = [];
        divSection1: JQuery<HTMLElement> | undefined;
        divSection2: JQuery<HTMLElement> | undefined;

        onContentReady()
        {
            //this.SetData();
            var div = $("<div>").css("display", "flex").css("align-items", "stretch").css("align-content", "stretch").css("flex-wrap", "wrap").appendTo(this.element);
            div.width("100%");
            this.divSection1 = $("<div>").width("350px").css("min-width", "350px").css("max-width", "370px").css("flex-grow", "1").appendTo(div);
            this.divSection2 = $("<div>").css("flex-grow", "3").appendTo(div);
            this.GenerateKpi();
            Gordic.Wfl.AC.WflBaseAC.InitControl(this);
            Gordic.Wfl.AC.WflBaseAC.CompleteMenu(this);
            if (this.Info && this.Info != "")
            {
                this.ResultType = Gin.Interface.TypVysledkuOperace.ProvedenoSUpozornenim;
                Wfl.AC.WflBaseAC.ShowFlashByContentInfo(this);
            }
        }

        GenerateKpi()
        {
            var that = this;

            if (this.model)
            {
                var l_Pole = [];

                var l_poleDetails = [];
                var l_DokSpisVeVlastnictvi =
                {
                    value: this.model.WflSouhrnInfo.DokSpisVeVlastnictvi!,
                    description: "jres:23900187", //RC 23900187 : ve vlastnictví SU
                    meaning: "info",
                    action: new GAction({
                        name: "actDokSpisVeVlastnictvi", run: function () {
                            that.NavigateTo("NeprideleneListPage");
                        }
                    })
                };
                l_poleDetails.push(l_DokSpisVeVlastnictvi);

                var l_DokSpisVRedistribuci =
                {
                    value: this.model.WflSouhrnInfo.DokSpisVRedistribuci!,
                    description: "jres:23900188", //RC 23900188 : v redistribuci
                    meaning: "info",
                    action: new GAction({
                        name: "actDokSpisVRedistribuci", run: function () {
                            that.NavigateTo("KPredaniVsemListPage");
                        }
                    })
                };
                l_poleDetails.push(l_DokSpisVRedistribuci);

                var l_DokSpisKPrevzeti =
                {
                    // name: "kPredaniKpi",
                    value: this.model.WflSouhrnInfo.DokSpisKPrevzeti!,
                    description: "jres:23900190", //RC 23900190 : k převzetí
                    meaning: "info",
                    action: new GAction({
                        name: "actDokSpisKPrevzeti", run: function () {
                            that.NavigateTo("RedistribuceKPrevzetiListPage");
                        }
                    })
                };
                l_poleDetails.push(l_DokSpisKPrevzeti);

                if (this.model.WflSouhrnInfo.POIEnabled)
                {
                    var l_DokSpisKPrevzetiZJinePOI =
                    {
                        // name: "kPredaniKpi",
                        value: this.model.WflSouhrnInfo.DokSpisKPrevzetiZJinePOI!,
                        description: "jres:23900194", //RC 23900194 : k převzetí z jiné POI
                        meaning: "info",
                        action: new GAction({
                            name: "actDokSpisKPrevzetiZJinePOI", run: function () {
                                that.NavigateTo("RedistribuceKPrevzetiListPage");
                            }
                        })
                    };
                    l_poleDetails.push(l_DokSpisKPrevzetiZJinePOI);
                }

                var l_dokSpis =
                    new GObservableObject({
                        title: "jres:23900186", //RC 23900186 : Dokumenty/spisy
                        detailsDirection: "vertical",
                        name: "DokSpis",
                        details: l_poleDetails,
                    });
                l_Pole.push(l_dokSpis);

                let l_ElPodani = new GObservableObject({
                    title: "jres:23900081", //RC 23900081 : El. podání
                    detailsDirection: "vertical",
                    name: "ElPodaniNezpracovana",
                    details: [
                        {
                            value: this.model.PodSouhrnInfo.ElPodaniNezpracovana!,
                            description: "jres:23900195", //RC 23900195 : nezpracovaná
                            meaning: "negative",
                            action: new GAction({
                                name: "actElPodaniNezpracovana", run: function () {
                                    that.NavigateTo("ElPodaniNezpracovanaAC");                                }
                            })
                        },
                    ]
                });

                l_Pole.push(l_ElPodani);

                var l_data = new Gordic.Data.View(l_Pole, { key: "name" });            

                this.scorecardItems = [
                    {
                        title: "jres:23900193", //RC 23900193 : Statistika
                        name: "scorecardItems",
                        mode: "vertical",
                        defaultSelected: false,
                        itemTemplate: Gordic.Prefabs.Panels.kpiMultiRowsTemplate().itemTemplate,
                        menuParams: [
                            {
                                icon: Gordic.Gin.Icons.ActionEnum.obcerstvit,
                                action: new GAction({
                                    name: "actRefresh",
                                    captionVisible: GAction.captionVisibility.never,
                                    caption: "jres:23900173", //RC 23900173 : Aktualizovat
                                    run: function (ev, ctx) {
                                        that.ShowCounts();
                                    }
                                })
                            }
                        ],
                        data: l_data
                    }
                ];
            };

            if (this.divSection1)
            {
                const formS = new Gordic.Forms.Form({ name: "frmSouhrn", layoutDescriptor: "L2M2S1" });

                this.defaultForm = $("<div>").appendTo(this.element).gform("createFrom", formS);

                $("<div>").appendTo(this.divSection1).gdashboardpanel({
                    data: this.scorecardItems,
                    layout: "horizontal",
                    title: "Test",
                    sortable: true
                });
            }
        };

        NavigateTo(name: string)
        {
            this.navigate('Gordic.Pod.WebControls.' + name, { ID: name + '#', taskId: name });
        };

        ShowCounts()
        {
            this.LoadData();
            var scorecardItems = this.scorecardItems[0].data;

            var l_DokSpis = scorecardItems.findByRowKey("DokSpis", false);
            l_DokSpis.update();

            var l_ElPodaniNezpracovana = scorecardItems.findByRowKey("ElPodaniNezpracovana", false);
            l_ElPodaniNezpracovana.update();

        };

        LoadData()
        {
            var that = this;
            Gin.Globals.ShowWaitLoadData(this);
            this.call<Interface.GPodAppSouhrnInfoDto>("LoadDataSouhrnu")
                .done(function (data) {
                    that.model = data;
                })
                .always(function () {
                    that.endOperation();
                });
        }

        ReloadData() {
            this.LoadData();
        }
    }
};
